"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TldGridItemComponent = void 0;
exports.TldItem = TldItem;
exports.default = TldGridItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/section-item/index.js"));
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _index2 = _interopRequireDefault(require("../../../elements/other/actions/index.js"));
var _image = require("@site/pattern-library-core/image");
var _adPlacementBanner = require("../ad-placement-banner");
var _text = _interopRequireDefault(require("@ux/text"));
const TldGridItemComponent = exports.TldGridItemComponent = /*#__PURE__*/(0, _react.styled)(_index.default)({
  name: "TldGridItemComponent",
  class: "pl-t1os8fnq"
});
const BannerContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "BannerContainer",
  class: "pl-b3qc067"
});
const Container = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Container",
  class: "pl-cellgsi"
});
const CTAContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "CTAContainer",
  class: "pl-c1kq8igs"
});
const HeaderContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "HeaderContainer",
  class: "pl-h1ey27pd"
});
const PriceContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "PriceContainer",
  class: "pl-pagko39"
});
function TldItem({
  item,
  width
}) {
  const {
    clickUrl,
    ctas,
    logo,
    tld,
    tagline,
    priceLockup,
    impressionUrl
  } = item;

  // clickUrl is set by kevel, this ensures kevel tracking is intact
  if (ctas && clickUrl) {
    ctas[0].href = clickUrl;
  }
  const {
    ctaRef
  } = (0, _patternLibraryUtils.useTrackingUpdate)(ctas);
  return /*#__PURE__*/_react2.default.createElement(Container, {
    "data-cy": "tld",
    logo: logo
  }, /*#__PURE__*/_react2.default.createElement(HeaderContainer, null, logo ? /*#__PURE__*/_react2.default.createElement(_image.LazyPicture, {
    defaultSrc: logo,
    defaultAltText: tld,
    height: 47,
    loading: width <= '992' ? 'eager' : 'lazy',
    dataCy: "image"
  }) : /*#__PURE__*/_react2.default.createElement(_text.default.h3, {
    size: 5,
    as: "title",
    "data-cy": "tld-grid-item-heading"
  }, `.${tld}`), tagline && /*#__PURE__*/_react2.default.createElement(_text.default.p, {
    size: 0,
    as: "paragraph",
    text: tagline
  })), /*#__PURE__*/_react2.default.createElement(PriceContainer, null, /*#__PURE__*/_react2.default.createElement(_price.default, (0, _extends2.default)({}, priceLockup, {
    priceTagDesign: "passive"
  }))), /*#__PURE__*/_react2.default.createElement(CTAContainer, {
    "data-cy": "tld-grid-item-cta",
    className: "cta",
    ref: ctaRef
  }, /*#__PURE__*/_react2.default.createElement(_index2.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...ctas[0],
      width: 'full'
    }]
  })), impressionUrl &&
  /*#__PURE__*/
  // only fires for kevel driven items
  _react2.default.createElement(_image.LazyPicture, {
    defaultSrc: impressionUrl,
    defaultAltText: "impression",
    loading: "lazy",
    dataCy: "impression"
  }));
}
TldItem.propTypes = {
  width: _propTypes.default.number,
  item: _propTypes.default.shape({
    id: _propTypes.default.string,
    impressionUrl: _propTypes.default.string,
    clickUrl: _propTypes.default.string,
    title: _propTypes.default.string,
    tagline: _propTypes.default.string,
    tld: _propTypes.default.string,
    logo: _propTypes.default.string,
    priceLockup: _propTypes.default.shape(_price.default.propTypes),
    backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
      rgb: _propTypes.default.string,
      contrastRgb: _propTypes.default.string
    }), _propTypes.default.shape({
      intent: _propTypes.default.string
    })]),
    position: _propTypes.default.number,
    ctas: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]))
  })
};
function BannerItem({
  item,
  width
}) {
  const {
    imageUrl,
    impressionUrl,
    clickUrl,
    title
  } = item;
  return /*#__PURE__*/_react2.default.createElement(BannerContainer, {
    "data-cy": "banner"
  }, /*#__PURE__*/_react2.default.createElement(_adPlacementBanner.AdPlacementBannerComponent, {
    adBanner: {
      imageUrl,
      impressionUrl,
      clickUrl,
      title
    }
    // eid={ eid } not currently used
    ,
    verticalPadding: "none",
    verticalMargin: "none",
    bannerSize: "300x250",
    padding: "none",
    rounded: true,
    loading: width <= '992' ? 'eager' : 'lazy'
  }), /*#__PURE__*/_react2.default.createElement("div", {
    className: "scroll-snap-anchor"
  }));
}
BannerItem.propTypes = {
  width: _propTypes.default.number,
  item: _propTypes.default.shape({
    imageUrl: _propTypes.default.string,
    impressionUrl: _propTypes.default.string,
    clickUrl: _propTypes.default.string,
    title: _propTypes.default.string
    // eid: PropTypes.string
  })
};

/**
 * @ignore @typedef {import('csstype').Property.TextAlign} TextAlign
 */
/**
 * Render column card with content alignment.
 * @module TldGridItem
 *
 * @param {Object} props React props
 * @param {string} props.id Id string
 * @param {Object} props.adBanner Ad banner object
 * @param {string} props.tld TLD string
 * @param {string} props.eid EID event string
 * @param {string} props.backgroundColor Item background color
 * @param {Object} props.ctas Ctas
 * @param {Object} props.priceLockup Price object
 * @param {Object} props.gridSettings Grid settings
 * @returns {React.ReactElement} section element
 * @public
 */
function TldGridItem({
  item,
  backgroundColor = {
    rgb: 'rgb(255,255,255)',
    contrastRgb: 'rgb(17,17,17)'
  }
}) {
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const {
    _name,
    id
  } = item;
  const sponsored = item.sponsored || item.sponsored === '';
  return /*#__PURE__*/_react2.default.createElement(TldGridItemComponent, (0, _extends2.default)({
    id: `id-tld-grid-item-${id}`,
    dataCy: "tld-grid-item",
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, _name && {
    ..._patternLibraryUtils.tracking.create(_name, false, true)
  }), item?.imageUrl ? /*#__PURE__*/_react2.default.createElement(BannerItem, {
    item: item,
    width: width
  }) : /*#__PURE__*/_react2.default.createElement(TldItem, {
    item: item,
    width: width
  }), sponsored && /*#__PURE__*/_react2.default.createElement(_text.default.span, {
    as: "paragraph",
    size: -1,
    className: "sponsored"
  }, item.sponsored));
}
TldGridItem.propTypes = {
  item: _propTypes.default.shape({
    _name: _propTypes.default.string,
    id: _propTypes.default.string,
    imageUrl: _propTypes.default.string,
    sponsored: _propTypes.default.string,
    ..._propTypes.default.oneOfType([_propTypes.default.shape(TldItem.propTypes), _propTypes.default.shape(BannerItem.propTypes)])
  }),
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string,
    contrastRgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })])
};